module.exports = __webpack_public_path__ + "img/1（带字）.3c7133f1.jpg";